export default {
    allowClientInboxUsersToEditUsers:
        '取引先による取引先受信箱ユーザー<0></0>の編集を許可',
    clientInboxUsers: '取引先受信箱ユーザー',
    clientInboxUsersTooltip:
        '通知メールを受ける、かつ取引先受信箱へアクセスできるメールアドレス',
    contactsAvailable:
        '直接入力、または本取引先の連絡先にあるメールアドレスから選択',
    duplicateEmails: '1メールアドレスは一度のみ設定できます。',
    noContact: '取引先にメールアドレスがありません。直接入力してください。',
    saveSettings: '保存',
    sectionHeaderSubTitle:
        '以下、本取引先宛の送付依頼において「取引先受信箱へ送信」に適用されます。',
    sectionHeaderTitle: '取引先受信箱へ送信',
};
